import { Tin } from "./Tin";
export class GermanTin extends Tin {
    validate(tin) {
        tin = tin.replace(/ |\//g, "");
        if (!/^[1-9][0-9]{10}$/.test(tin)) {
            return false;
        }
        const firstTen = tin.slice(0, 10);
        const occurrences = firstTen
            .split("")
            .reduce((acc, d) => acc.set(d, (acc.get(d) || 0) + 1), new Map());
        const keys = [...occurrences.keys()];
        const values = [...occurrences.values()];
        if (keys.length !== 9 && keys.length !== 8) {
            return false;
        }
        if (keys.length === 8) {
            const maxOccurrences = values.reduce((max, num) => Math.max(max, num));
            if (maxOccurrences === 2 || /(\d)\1\1/.test(firstTen)) {
                return false;
            }
        }
        let m11 = 10;
        let m10 = 0;
        for (let i = 0; i < 10; i++) {
            m10 = (parseInt(tin[i], 10) + m11) % 10;
            if (m10 === 0) {
                m10 = 10;
            }
            m11 = (2 * m10) % 11;
        }
        let digit = 11 - m11;
        if (digit === 10) {
            digit = 0;
        }
        return digit === parseInt(tin[10], 10);
    }
    getNormalizedTin() {
        return this.tin.replace(/ |\//g, "");
    }
    getBirthDate() {
        return undefined;
    }
}
